import React from "react";
import ContributedCard from "../../contributercard";
const NCC = () => {
  return (
    <>
      <ContributedCard />
      <div className="container" style={{ marginTop: "150px" }}>
        <div className="row">
          <div className="col-lg-4 text-center text-lg-start pb-5">
            <img style={{ height: "300px" }} src="assets/contributedAssets/NCC/1.jpg" />
          </div>
          <div className="col-lg-8 order">
            <h1 style={{ backgroundColor: "#333", color: "aliceblue", textAlign: "center" }}>ABOUT</h1>
            <h2 style={{ fontSize: "larger", textAlign: "justify" }}>
              National Cadet Corps (NCC) is a voluntary tri-service youth organization which aims at instilling characteristics of leadership,discipline and social service.NCC is a way of
              life,following our motto of "unity and discipline".NCC works relentlessly towards upholding the unity and integrity of our nation by moulding the upcoming generation into selfless
              citizens serving motherland with utmost honesty, irrespective of the field they aspire to choose.NCC throughout its army sub using provides basic Military training and defence knowledge
              at institutional level as well as Annual Training Camps (ATC),Ek Bharat Shreshth Bharat (EBSB),National Integration Camps(NIC),Basic Leadership Camps(BLC) organized at regular intervals
              to develop ideal Physical strength and give an essence of armed forces.
            </h2>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4">
            {" "}
            <img style={{ height: "300px" }} src="assets/contributedAssets/NCC/2.jpg" />
          </div>

          <div className="col-lg-8 p-3 ">
            <h6>
              Name - Dr.Amrit Kaushal. Qualification - Shastri, B.ed, M.ed, Ma.Sanskrit(Gold Medalist) Ph.d, Net Jrf, Ctet, Tgt Pgt Htet, Army Test. E-Mail - kamrit868@gmail.com. Mobile - 9467541979.
            </h6>
          </div>
        </div>
        <div className="officers">
          <div style={{ marginTop: "30px" }} className="row">
            <div className="col-lg-6 text-start">
              <h5 className="parah3">SENIOR UNDER OFFICER</h5>
              <img className="seniorofficer" style={{ height: "350px" }} src="assets/contributedAssets/NCC/3.jpg"></img>
            </div>
            <div className="col-lg-6 text-start">
              <h5 className="parah4"> UNDER OFFICER</h5>
              <img className="underofficer" style={{ height: "400px" }} src="assets/contributedAssets/NCC/4.jpg"></img>
            </div>
          </div>
        </div>

        <h2 style={{ backgroundColor: "#333", color: "aliceblue", marginTop: "30px", textAlign: "center" }} className="parah5">
          OUR BEST CADETS
        </h2>

        <div style={{ marginTop: "30px" }} className="row">
          <div className="col lg-6">
            <img style={{ height: "200px" }} className="image5" src="assets/contributedAssets/NCC/5.jpg" />
          </div>
          <div className="col lg-6">
            <img style={{ height: "200px" }} className="image6" src="assets/contributedAssets/NCC/6.jpg" />
          </div>
          <div className="col lg-6">
            <img style={{ height: "200px" }} className="image7" src="assets/contributedAssets/NCC/7.jpg" />
          </div>
        </div>
        <h2 style={{ backgroundColor: "#333", color: "aliceblue", marginTop: "50px", textAlign: "center" }} className="intro">
          INTRODUCTION ABOUT NCC IN COLLEGE
        </h2>
        <p style={{ textAlign: "justify" }} className="intro2">
          <h4>
            NCC SVSD Bhatoli ensures physical aspect of health but also by encouraging the strengthening of mental and social health by conducting competitions, essay, poetry and slogan writing
            competitions accomplished by interactive webinars with eminent personalities from reversed fields. NCC has total 54 vacancy running by SVSD PG College Bhatoli under 1 HP Boys Btalion solan
            under Shimla NCC Director.
          </h4>{" "}
        </p>
        <h3 style={{ backgroundColor: "#333", color: "aliceblue" }} className="achieve">
          MAJOR EVENTS ORGANISED
        </h3>
        <p className="treeplantation">
          <h3>TREE PLANTATION :</h3>
          <h4 style={{ textAlign: "justify" }}>
            This activity was organized from 13th - 29th July 2022. Webinars were conducted on tree plantation awareness. Various competitions like slogan writing, photography, poetry, extempore and
            poster making were organized. Cadets actively participated in the entire program with enthusiasm, planting trees in their localities and practicing hydroponics. Then an extempore
            competition was organized on 24th July.
          </h4>
          <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img style={{ height: "600px", width: "500px" }} src="assets/contributedAssets/NCC/8.jpg" className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img style={{ height: "600px", width: "500px" }} src="assets/contributedAssets/NCC/9.jpg" className="d-block w-100" alt="..." />
              </div>
              <div className="carousel-item">
                <img style={{ height: "600px", width: "500px" }} src="assets/contributedAssets/NCC/10.jpg" className="d-block w-100" alt="..." />
              </div>
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </p>

        <p className="kargilvijaydiwas">
          <h3> KARGIL VIJAY DIWAS :</h3>
          <h4 style={{ textAlign: "justify" }}>
            Kargil Vijay Diwas organized on 26th July. NCC Hansraj celebrated the valour of our martyrs on 26th July 2022. A webinar was organized commemorating Operation Vijay. The event discussed
            the war memorial, the various difficulties in the war and how all of them were overcome. Cadets from various institutions participated in it and made it a great success.
          </h4>
        </p>

        <p className="swachhtadiwas">
          <h3> SWACHHTA DIWAS :</h3>
          <h4 style={{ textAlign: "justify" }}>
            Cadets participated in Rajpath in a ten day program where they sensitized the people with the importance of cleanliness. They extensively participated in the rallies organized there. Apart
            from this, cadets participated in the webinar organised on Gandhi Jayanti i.e. 2 October 2022 highlighting the ways to ensure cleanliness. We organised a Yoga session on 30th August,
            Aerobics session on 6th September, zumba session on 13th September and meditation session on 20th September. A short speech competition was organised on 10th October, a quiz competition
            was done on 17th October and a cultural event was organised on 27th october.
          </h4>
        </p>
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img style={{ height: "600px", width: "500px" }} src="assets/contributedAssets/NCC/11.jpg" className="d-block w-100" alt="..." />
            </div>
            <div className="carousel-item">
              <img style={{ height: "600px", width: "500px" }} src="assets/contributedAssets/NCC/12.jpg" className="d-block w-100" alt="..." />
            </div>
            <div className="carousel-item">
              <img style={{ height: "600px", width: "500px" }} src="assets/contributedAssets/NCC/13.jpg" className="d-block w-100" alt="..." />
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>

        <h3> NCC DAY :</h3>
        <h4 style={{ textAlign: "justify" }}>
          The event was celebrated on 22nd November 2022. The main highlights of the event comprised of showcasing the history of the organization, the benefits and the notable alumni of NCC. NCC day
          is celebrated every year on the 4th Sunday in November. NCC day is observed throughout the country. The raising day is being celebrated all over the country with cadets participating in
          marches, blood donation camps and social development programmes.
        </h4>

        <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="assets/contributedAssets/NCC/14.jpg" className="d-block w-100" alt="..." />
            </div>
            <div className="carousel-item">
              <img src="assets/contributedAssets/NCC/15.jpg" className="d-block w-100" alt="..." />
            </div>
            <div className="carousel-item">
              <img src="assets/contributedAssets/NCC/16.jpg" className="d-block w-100" alt="..." />
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>

        <p className="independenceday">
          <h3>INDEPENDENCE DAY</h3>
          <h4 style={{ textAlign: "justify" }}>
            This event was organized on 14th August.. The entire event was conducted in online mode in the presence of our esteemed guest Prof Rama, Prof P C Joshi (Pro Vice Chancellor, University of
            Delhi) and Dr Nitin Malik (Registrar, Dr B R Ambedkar University). Beginning from flag hoisting and guard of honour, the event proceeded with cultural performances, patriotic poetry and
            songs.
          </h4>
        </p>

        <div className="row">
          <h1 style={{ backgroundColor: "#333", color: "aliceblue", marginTop: "20px", textAlign: "center" }}>SOME NCC PICTURES AND MEMORIES</h1>
          <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
            <img src="assets/contributedAssets/NCC/17.jpg" className="w-100 shadow-1-strong rounded mb-4" alt="Boat on Calm Water" />

            <img src="assets/contributedAssets/NCC/18.jpg" className="w-100 shadow-1-strong rounded mb-4" alt="Wintry Mountain Landscape" />
          </div>

          <div className="col-lg-4 mb-4 mb-lg-0">
            <img src="assets/contributedAssets/NCC/19.jpg" className="w-100 shadow-1-strong rounded mb-4" alt="Mountains in the Clouds" />

            <img src="assets/contributedAssets/NCC/20.jpg" className="w-100 shadow-1-strong rounded mb-4" alt="Boat on Calm Water" />
          </div>

          <div className="col-lg-4 mb-4 mb-lg-0">
            <img src="assets/contributedAssets/NCC/21.jpg" className="w-100 shadow-1-strong rounded mb-4" alt="Waves at Sea" />

            <img src="assets/contributedAssets/NCC/22.jpg" className="w-100 shadow-1-strong rounded mb-4" alt="..." />
          </div>
        </div>
        <div className="text-center">
          <p style={{ fontSize: "larger" }}>
            Created By:
            <a href="https://instagram.com/shreyaahh.ll?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D">Shreya</a>
          </p>
          <div className="text-center">
            <p style={{ fontSize: "larger" }}>
              <a href="https://instagram.com/pratham__bangia_?igshid=NGExMmI2YTkyZg==">Pratham Bangia</a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
export default NCC;
